export default __webpack_public_path__ + "static/media/Error.e06e3ceb.gif";